import React, { useEffect, useState, useRef } from 'react';
import { func } from 'prop-types';
import styles from './styles/styles.module.scss';
import useScreenLock from '../../../hooks/useScreenLock';

const BottomTray = ({ children, closeTray }) => {
  const [isMounted, toggleIsMounted] = useScreenLock();
  const [trayPosition, updateTrayPosition] = useState(-500);
  const trayRef = useRef();
  const visibleRef = useRef(false);

  const handleTransitionEnd = () => {
    if (visibleRef.current) {
      closeTray();
    }
  };

  useEffect(() => {
    updateTrayPosition(trayRef.current.offsetHeight * -1);
    updateTrayPosition(0);
    trayRef.current.addEventListener('transitionend', handleTransitionEnd, false);

    return () => {
      trayRef.current.removeEventListener('transitionend', handleTransitionEnd, false);
    };
  }, []);

  const handleCloseTray = () => {
    visibleRef.current = true;
    updateTrayPosition(trayRef.current.offsetHeight * -1);
  };

  return (
    <div className={styles.container}>
      <div className={styles.opacScreen} onClick={handleCloseTray} />
      <div className={`${styles.tray}`} style={{ bottom: trayPosition }} ref={trayRef}>
        {children}
      </div>
    </div>
  );
};

BottomTray.propTypes = {
  closeTray: func.isRequired
};

export default BottomTray;
